import { Calendar } from 'lucide-react';
import SectionHeader from './SectionHeader';
import { PANCHANG_TRANSLATIONS } from "../../../../languages/panchang";

interface HinduCalendarProps {
    hinduCalendar: {
        shaka_samvat?: string;
        samvatsara?: string;  // 60-year cycle name (e.g., Vishvavasu)
        vikram_samvat?: string;
        kali_samvat?: string;
        month_purnimanta?: string;
        month_amanta?: string;
        pravishte?: string;
    } | null;
    language: string;
}

const HinduCalendar = ({ hinduCalendar, language }: HinduCalendarProps) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = PANCHANG_TRANSLATIONS[langKey];

    return (
        <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-4 md:p-8 shadow-xl">
            <SectionHeader icon={Calendar} title={t.hinduCalendar} />

            {/* Samvatsara - Featured at top */}
            {hinduCalendar?.samvatsara && (
                <div className="bg-gradient-to-r from-purple-600/20 to-indigo-600/20 border border-purple-500/30 rounded-xl p-3 md:p-4 mb-5 md:mb-6 text-center">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300 font-bold uppercase tracking-wider leading-tight mb-1 font-sans">
                        {t.samvatsara} ({t.yearCycle})
                    </p>
                    <p className="text-sm sm:text-base md:text-2xl font-bold leading-tight text-white font-sans">{hinduCalendar.samvatsara}</p>
                </div>
            )}

            {/* Samvat Years Row */}
            <div className="grid grid-cols-3 gap-3 md:gap-4 mb-3 md:mb-4">
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.shakaSamvat}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.shaka_samvat || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.vikramSamvat}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.vikram_samvat || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.kaliSamvat}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.kali_samvat || '---'}</p>
                </div>
            </div>

            {/* Months and Pravishte Row */}
            <div className="grid grid-cols-3 gap-3 md:gap-4">
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.monthPurnimanta}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.month_purnimanta || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.monthAmanta}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.month_amanta || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1.5 md:mb-2 font-sans">{t.pravishte}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-white font-sans">{hinduCalendar?.pravishte || '---'}</p>
                </div>
            </div>
        </div>
    );
};

export default HinduCalendar;
